import React from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
const REACT_APP_MEDIA_URL = process.env.REACT_APP_MEDIA_URL || "";
const DocumentViewer = ({ document, onClose }) => {
  if (!document) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-900">Document Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {/* Document Title */}
          <div className="mb-6">
            <h4 className="text-lg font-semibold text-gray-700 mb-2">Title</h4>
            <p className="text-gray-900 bg-gray-50 p-3 rounded-md">
              {document.title?.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) || "N/A"}
            </p>
          </div>

          {/* Document Category */}
          {/* <div className="mb-6">
            <h4 className="text-lg font-semibold text-gray-700 mb-2">Category</h4>
            <p className="text-gray-900 bg-gray-50 p-3 rounded-md">
              {document.category || "Not specified"}
            </p>
          </div> */}

          {/* Document Preview/Download */}
          <div className="mb-6">
            <h4 className="text-lg font-semibold text-gray-700 mb-2">Document</h4>
            <div className="bg-gray-50 p-4 rounded-md">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="font-medium text-gray-900">
                    {document.originalName || document.fileName?.split("/").pop() || "Document"}
                  </p>
                  <p className="text-sm text-gray-500">
                    {document.fileType} • {document.fileSize ? `${(document.fileSize / 1024).toFixed(2)} KB` : "Size not available"}
                  </p>
                </div>
                <Link
                  to={`${REACT_APP_MEDIA_URL}${document.fileName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
                >
                  View/Download
                </Link>
              </div>
              {document.fileType?.startsWith("image/") && (
                <div className="mt-4 border rounded-md overflow-hidden">
                  <img
                    src={`${REACT_APP_MEDIA_URL}${document.fileName}`}
                    alt={document.title || "Document"}
                    className="w-full h-auto max-h-64 object-contain"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/300x200?text=Image+Not+Available";
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Signature Section */}
          <div className="mb-6">
            <h4 className="text-lg font-semibold text-gray-700 mb-2">Signature</h4>
            {document.signature ? (
              <div className="bg-gray-50 p-4 rounded-md">
                {/* Signature Image */}
                <div className="mb-4">
                  {document.signature.data ? (
                    <div className="border rounded-md overflow-hidden max-w-xs">
                      <img
                        src={document.signature.data}
                        alt="Signature"
                        className="w-full h-auto bg-white"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.parentElement.innerHTML = '<div class="p-4 text-center text-gray-500">Signature image not available</div>';
                        }}
                      />
                    </div>
                  ) : (
                    <p className="text-gray-500">No signature image available</p>
                  )}
                </div>

                {/* Signature Details */}
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="font-medium text-gray-700 mb-1">Signed By</p>
                    <p className="text-gray-900">{document.signature.signedBy || "N/A"}</p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-700 mb-1">Signature Date</p>
                    <p className="text-gray-900">
                      {document.signature.signatureDate
                        ? dayjs(document.signature.signatureDate).format("MM-DD-YYYY HH:mm:ss")
                        : "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-700 mb-1">Uploaded At</p>
                    <p className="text-gray-900">
                      {document.uploadedAt
                        ? dayjs(document.uploadedAt).format("MM-DD-YYYY HH:mm:ss")
                        : "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-700 mb-1">Last Updated</p>
                    <p className="text-gray-900">
                      {document.updatedAt
                        ? dayjs(document.updatedAt).format("MM-DD-YYYY HH:mm:ss")
                        : "N/A"}
                    </p>
                  </div>
                </div> */}
              </div>
            ) : (
              <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
                <p className="text-yellow-800">No signature found for this document</p>
              </div>
            )}
          </div>

          {/* Additional Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="text-lg font-semibold text-gray-700 mb-2">Expiry Date</h4>
              <div className="bg-gray-50 p-3 rounded-md">
                {document.expiryDate ? (
                  <div>
                    <p className="text-gray-900">
                      {dayjs(document.expiryDate).format("MM-DD-YYYY")}
                    </p>
                    <p className={`text-sm mt-1 ${
                      new Date(document.expiryDate) < new Date()
                        ? "text-red-600"
                        : new Date(document.expiryDate) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
                        ? "text-yellow-600"
                        : "text-green-600"
                    }`}>
                      {new Date(document.expiryDate) < new Date()
                        ? "Expired"
                        : new Date(document.expiryDate) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
                        ? "Expiring soon"
                        : "Valid"}
                    </p>
                  </div>
                ) : (
                  <p className="text-gray-500">No expiry date set</p>
                )}
              </div>
            </div>

            {/* <div>
              <h4 className="text-lg font-semibold text-gray-700 mb-2">Status</h4>
              <div className="bg-gray-50 p-3 rounded-md">
                <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                  document.status === "active"
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                }`}>
                  {document.status?.toUpperCase() || "UNKNOWN"}
                </span>
              </div>
            </div> */}
          </div>
        </div>

        {/* Footer */}
        {/* <div className="flex items-center justify-end p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
          >
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default DocumentViewer;